export { Box } from '@mui/material';
export type { BoxProps } from '@mui/material';
